import { UserPermission } from '@adornis/users/db/types.js';

export enum MatchingPermission {
  CREATE_EDIT_DELETE_USERS = 'CREATE_EDIT_DELETE_USERS',
  CREATE_EDIT_DELETE_ADMIN_USERS = 'CREATE_EDIT_DELETE_ADMIN_USERS',
  CREATE_EDIT_DELETE_TIMEFRAMES = 'CREATE_EDIT_DELETE_TIMEFRAMES',
  CREATE_EDIT_DELETE_MATCHES = 'CREATE_EDIT_DELETE_MATCHES',
  EDIT_TRANSLATIONS = 'EDIT_TRANSLATIONS',
  EDIT_GLOBAL_CONFIG = 'EDIT_GLOBAL_CONFIG',
  MANAGE_MAIL_TEMPLATES = 'MANAGE_MAIL_TEMPLATES',
  VIEW_ADMIN_DASHBOARD = 'VIEW_ADMIN_DASHBOARD',
  CHANGE_ROLES = UserPermission.ChangeRoles,
  CHANGE_PASSWORD = UserPermission.ChangePassword,
}
